export const getColumnsForTable = (columns, basicKeys = []) => columns.filter(obj => !basicKeys.length || basicKeys.includes(obj.dataField));
